import type { ReactNode } from "react";
import { DashboardLayout } from "@/components/layout/dashboard-layout";
import { SecurityAppLayout } from "@/components/layout/security-app-layout";
import { useAuth } from "@/contexts/auth-context";

interface DashboardLayoutRouteProps {
  children: ReactNode;
}

/**
 * Dashboard Layout Wrapper
 *
 * Wraps route content with the dashboard layout (sidebar, header, etc).
 * Applied automatically when route config specifies layout: "dashboard".
 *
 * Excepção: a conta de posto de segurança nunca vê o dashboard da empresa —
 * nem sidebar, nem header, nem sino de notificações. Recebe uma casca própria,
 * de app móvel. Isto vive aqui (e não na página) porque TODAS as rotas de
 * dashboard passam por este wrapper: mesmo que a conta acerte noutro URL, não
 * há maneira de a app da empresa se desenhar à volta dela.
 */
export const DashboardLayoutRoute = ({
  children,
}: DashboardLayoutRouteProps) => {
  const { user } = useAuth();

  if (user?.isSecurityAccount) {
    return <SecurityAppLayout>{children}</SecurityAppLayout>;
  }

  return <DashboardLayout>{children}</DashboardLayout>;
};
